var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading.lock",
            value: _vm.fullscreenLoading,
            expression: "fullscreenLoading",
            modifiers: { lock: true },
          },
        ],
        staticClass: "main-content fullCycle fullCss",
        style: _vm.mainContentViewHeight,
      },
      [
        _c("headerCom", {
          staticClass: "header",
          attrs: { datacount: _vm.navTotal, tabs: false, type: 3 },
          on: {
            navchange: _vm.navClickHandle,
            searchclick: _vm.searchClickHandle,
            showBox: _vm.showBoxHandle,
          },
        }),
        _vm.showFlag
          ? _c("screenCom", {
              staticClass: "screen",
              attrs: {
                navClick: _vm.systemType,
                projectTypeList: _vm.projectTypeList,
                type: 4,
              },
              on: { projectemit: _vm.projectEmitHandle },
            })
          : _vm._e(),
        _c(
          "div",
          { staticClass: "my_table" },
          [
            _vm.dataMsg.length == 0
              ? _c("div", { staticClass: "no_message" }, [
                  _c("p", [_vm._v("暂无数据")]),
                ])
              : _c(
                  "div",
                  { staticClass: "project_item" },
                  [
                    _vm._m(0),
                    _vm._l(_vm.dataMsg, function (item, i) {
                      return _c("projectCom", {
                        key: i,
                        staticClass: "project_par",
                        attrs: {
                          data: item,
                          hasViewBtnPer: _vm.hasBtnPermission(
                            "supperviseion_flowEff_detail_btn"
                          ),
                          systemType: _vm.systemType,
                          type: 4,
                          clickRowEvent: false,
                        },
                      })
                    }),
                  ],
                  2
                ),
            _c("paginationCom", {
              staticClass: "limit",
              attrs: { options: _vm.paginationOpt },
              on: {
                sizechange: _vm.sizeChangeHandle,
                pagechange: _vm.pageChangeHandle,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "radioBox" }, [
      _c("div", [
        _c("span", { staticStyle: { background: "#1890FF" } }),
        _vm._v("未超出操作时效范围"),
      ]),
      _c("div", [
        _c("span", { staticStyle: { background: "#ffc500" } }),
        _vm._v("快要超出操作时效范围"),
      ]),
      _c("div", [
        _c("span", { staticStyle: { background: "#FF9900" } }),
        _vm._v("即将超出操作时效范围"),
      ]),
      _c("div", [
        _c("span", { staticStyle: { background: "#F23030" } }),
        _vm._v("已超出操作时效范围"),
      ]),
      _c("div", [
        _c("span", { staticStyle: { background: "#FFFFFF" } }),
        _vm._v("未到该操作环节"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }